import { EqlFieldName } from '@modules/common/constants';
import { SortBy, VisualisationType } from '@modules/quantify/store/types';
import { EqlField } from 'generated/graphql';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

interface getOrderFunctionParams {
  sortBy: SortBy | null;
  groupBy: EqlField | null;
  activeVisualisationType: VisualisationType;
  shouldShowAnomalies: boolean;
}

export function getQuantifyOrderFunction({
  sortBy,
  groupBy,
  activeVisualisationType,
  shouldShowAnomalies,
}: getOrderFunctionParams) {
  if (!groupBy?.field) {
    return null;
  }

  const getOrderParams = () => {
    const order = sortBy?.isAsc ? 'asc' : 'desc';
    const isTimeSeriesChart =
      activeVisualisationType === VisualisationType.TREND;

    if (!sortBy?.field) {
      if (shouldShowAnomalies && isTimeSeriesChart) {
        return ['anomalous-value', order];
      }

      return null;
    }

    switch (sortBy.field) {
      case 'label': {
        if (
          groupBy.field === EqlFieldName.Entity ||
          groupBy.field === EqlFieldName.Reason ||
          groupBy.field === EqlFieldName.UserSentiment
        ) {
          return null;
        }

        return ['metadata-value', order];
      }
      case 'value': {
        if (shouldShowAnomalies && isTimeSeriesChart) {
          return ['anomalous-value', order];
        }

        return [isTimeSeriesChart ? 'volume' : sortBy.field, order];
      }
      default: {
        const isTimePeriodColumn = isTimeSeriesChart;

        if (shouldShowAnomalies && isTimePeriodColumn) {
          return ['anomalous-value', order];
        }

        if (isTimePeriodColumn && !isNaN(Number(sortBy.field))) {
          return ['bucket-timestamp', Number(sortBy.field), order];
        }

        return ['keyword-sentiment', sortBy.field.toLowerCase(), order];
      }
    }
  };

  const params = getOrderParams();

  if (!params) {
    return null;
  }

  return {
    name: EQLFunctionName.Order,
    params,
  };
}
